import html2canvas from 'html2canvas';

const PAGE_HEIGHT = 897;
const PAGE_WIDTH = 762;
const PADDING = 16;

async function buildPages(images) {
  const pages = [];
  let currentPage = document.createElement('div');
  currentPage.style.height = `${PAGE_HEIGHT}px`;
  currentPage.style.width = `${PAGE_WIDTH}px`;
  const PAGES_CONTAINER = document.querySelector('#progress-export-container');
  PAGES_CONTAINER.appendChild(currentPage);
  let currentHeight = 0;

  const imagePromises = images.map(imgSrc => {
      return new Promise((resolve, reject) => {
          const img = new Image(PAGE_WIDTH);
          img.src = imgSrc;

          img.onload = () => {
              if (currentHeight + img.height + PADDING <= PAGE_HEIGHT) {
                  currentPage.appendChild(img);
                  currentHeight += (img.height + PADDING);
              } else {
                  pages.push(currentPage);
                  currentPage = document.createElement('div');
                  currentPage.style.height = `${PAGE_HEIGHT}px`;
                  currentPage.style.width = `${PAGE_WIDTH}px`;
                  PAGES_CONTAINER.appendChild(currentPage);
                  currentPage.appendChild(img);
                  currentHeight = img.height + PADDING;
              }
              resolve();
          };

          img.onerror = reject; 
      });
  });


  return Promise.all(imagePromises)
      .then(() => {
          if (currentPage.childElementCount > 0) {
              pages.push(currentPage);
          }
          return pages;
      }).catch((error) => console.error('There was an error in images creation and its addition to the page', error));
}

export default async function buildPagesAndConvertToImages(images) {
    const pages = await buildPages(images)
    
    const canvasPromises = pages.map(async page => {
        const canvas = await html2canvas(page);
        return canvas.toDataURL("image/png");
    });
    
    const imageSources = await Promise.all(canvasPromises);

    return imageSources;
}
